<template>
	<v-vehicle-sell></v-vehicle-sell>
</template>

<script>
	import VehicleSell from "./sell";

  export default {
	name: 'Index',
	components: {
		'v-vehicle-sell': VehicleSell
	},
	data (){
		return {
			auction: {live: ""},
			step: 0
		}
	},
	props: {
		activeScrollToCars: {dafault: ""},
		prevStep: {default: 0}
	},
	beforeMount(){
		const cur = this;
		this.axios.get("auctions/next").then(result => {
			if(typeof result.data.length != undefined){
				cur.auction = result.data;
			}
		}).catch(() => {
		})
		if(this.$store.state.isLogged){
			this.axios.post(process.env.VUE_APP_BASE_URL+'users/favorites', { cookie: this.$cookies.get("MCart") } ).then(res => {
				cur.$store.commit('set_favorites', res.data.cars_id)
				cur.$forceUpdate();
			});
		}
	},
	mounted(){
		this.send_count()
		this.step = this.prevStep;
		if(this.activeScrollToCars){
			this.scrollToCars();
		}
	},
	methods: {
		send_count(){
			this.axios.post("meters", {id: 212928, url: window.location.href, width: window.innerWidth, height: window.innerHeight}).then(() => {})
		},
		scrollFromHead() {
			window.scroll({
				top: document.querySelector('.scroll-receiver').offsetTop - 150,
				behavior: 'smooth'
			});
		},
		scrollToCars() {
			window.scroll({
				top: document.querySelector('.car-grid').offsetTop - 100,
				behavior: 'smooth'
			});
		},
		closeAndScrollToCars(){
			this.$bvModal.hide('modal-auction');
			this.scrollToCars();
		},
	}
}
</script>
<style >
	#modal-auction___BV_modal_outer_{
		z-index: 1060 !important;
	}
</style>
